import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import styled, { injectGlobal } from 'styled-components';
import { em } from 'polished';
import { AppBar, Toolbar } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import PrintIcon from '@material-ui/icons/Print';
import { appTheme } from '../../../theme';
import AppRoutes from './AppRoutes';
import { Button, mediaQuery, LinkButton, Logo } from '../../common';
import { DRAWER_WIDTH } from '../constants';
import { adminRoutes, userRoutes } from '../routes';
import NavigationSidebar from './NavigationSidebar';
import { Plugins } from '@capacitor/core';

const { SplashScreen } = Plugins;

injectGlobal`
  * {
    box-sizing: border-box;
  }

  body,
  html {
    color: ${appTheme.system.black};
    font-family: ${appTheme.fonts.sansSerif};
    margin: 0;
    padding: 0;
  }
`;

const Wrapper = styled.div`
  display: block;
  padding-top: ${appTheme.sizing.headerHeight};
`;

const ActionItemWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const ContainerToolbar = styled(Toolbar)`
  justify-content: space-between;
  padding: ${em('10px')};
  padding-top: ${appTheme.sizing.toolbarPaddingTop};
`;

const MenuButton = styled(Button)`
  ${mediaQuery.medium`
    display: none;
    `};
`;

const PDFLink = styled(NavLink)`
  color: ${appTheme.system.black};
  display: flex;

  ${mediaQuery.xsmall`
    display: none;
  `};
`;

const Main = styled.main`
  display: block; /* IE11 defaults to display: inline  */
  height: calc(100vh - ${appTheme.sizing.headerHeight});
  background-color: ${appTheme.system.main};

  ${mediaQuery.medium`
    margin-left: ${props => (props.isLoggedIn ? em(DRAWER_WIDTH) : 0)};
  `};
`;

class PalliativeCareRoot extends React.Component {
  state = {
    isDrawerOpen: false,
  };

  handleToggleDrawer = () => {
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen });
  };

  handleCloseDrawer = () => {
    this.setState({
      isDrawerOpen: false,
    });
  };

  render() {
    const { isAdmin, isLoggedIn, onLogout, location } = this.props;
    const menuItems = isAdmin ? adminRoutes : userRoutes;
    const isLoginPage = location.pathname === '/login';

    SplashScreen.hide();

    return (
      <Wrapper>
        <AppBar color="secondary">
          <ContainerToolbar>
            {isLoggedIn && (
              <MenuButton
                className="menu-button"
                color="inherit"
                onClick={this.handleToggleDrawer}
                variant="text"
              >
                Menu
              </MenuButton>
            )}
            <Link to="/">
              <Logo />
            </Link>
            <ActionItemWrapper>
              {isLoggedIn && !isAdmin && (
                <PDFLink to="/pdf">
                  <Icon color="inherit">
                    <PrintIcon />
                  </Icon>
                </PDFLink>
              )}
              {isLoggedIn ? (
                <Button color="inherit" onClick={onLogout} variant="text">
                  Logout
                </Button>
              ) : (
                !isLoginPage && <LinkButton to="/login">Login</LinkButton>
              )}
            </ActionItemWrapper>
          </ContainerToolbar>
        </AppBar>
        {isLoggedIn && (
          <NavigationSidebar
            handleCloseDrawer={this.handleCloseDrawer}
            isOpen={this.state.isDrawerOpen}
            menuItems={menuItems}
          />
        )}
        <Main isLoggedIn={isLoggedIn}>
          <AppRoutes isAdmin={isAdmin} isLoggedIn={isLoggedIn} />
        </Main>
      </Wrapper>
    );
  }
}

PalliativeCareRoot.propTypes = {
  location: PropTypes.object.isRequired,
  onLogout: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
};

PalliativeCareRoot.defaultProps = {
  isAdmin: false,
  isLoggedIn: false,
};

export default PalliativeCareRoot;



// WEBPACK FOOTER //
// ./src/modules/App/components/PalliativeCareRoot.js